import type React from 'react';

import { ImportExportRounded } from '@mui/icons-material';
import { Badge, CircularProgress, Tooltip, useTheme } from '@mui/material';
import { Link, useGetIdentity, useGetList, useTranslate } from 'react-admin';

import type { Task } from '@ragu-components/ord-types';

export const TaskNotification = (): React.ReactElement => {
  // The realm id is read from the (reactive) identity resolved by the auth
  // provider after login. Gating the request on it prevents the task list
  // from being fetched with an empty domain before the session is available,
  // which would otherwise leave the badge missing on login.
  const { identity } = useGetIdentity();
  const realmId = (identity?.realm_id as string | undefined) ?? '';
  const { isLoading, total } = useGetList<Task>(
    'tasks',
    { pagination: { page: 1, perPage: 10 } },
    { enabled: realmId !== '' }
  );
  const translate = useTranslate();
  const theme = useTheme();

  if (isLoading) {
    return <CircularProgress size={'16px'} sx={{ color: theme.palette.text.primary }} />;
  }
  if (total !== undefined && total > 0) {
    return (
      <Link to='/tasks'>
        <Tooltip title={translate('resources.tasks.name')}>
          <Badge badgeContent={total} color='error'>
            <ImportExportRounded sx={{ color: theme.palette.text.primary }} />
          </Badge>
        </Tooltip>
      </Link>
    );
  }
  return <> </>;
};
